import {FC} from 'react'
import {Link} from 'react-router-dom'

type Props = {
  tabs: Array<{title: string; slug: string; href: string; badgeValue?: string}>
  activeTab: string
}

const NavTabs: FC<Props> = ({tabs, activeTab}) => {
  return (
    <>
      {tabs.length > 0 && (
        <div className='px-10'>
          <div className='d-flex h-55px border-bottom'>
            <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-semibold flex-nowrap '>
              {tabs.map((tab) => (
                <li key={tab.slug} className='nav-item'>
                  <Link
                    to={tab.href}
                    style={{
                      color: '#6a7282',
                    }}
                    className={`nav-link fw-bold me-6 text-active-primary ${
                      activeTab === tab.slug ? 'active' : ''
                    }`}
                  >
                    {tab.title}

                    {tab.badgeValue && (
                      <div
                        className='d-flex justify-content-center align-items-center'
                        style={{
                          background: '#E5E7EB',
                          borderRadius: '9999px',
                          width: '20px',
                          height: '20px',
                          marginInlineStart: '6px',
                        }}
                      >
                        <span className='fw-medium' style={{color: '#1F2A37', fontSize: '12px'}}>
                          {tab.badgeValue}
                        </span>
                      </div>
                    )}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </>
  )
}

export default NavTabs
